import React from "react";
import { Link, withRouter } from "react-router-dom";

const ResetPasswordEmail = props => {
  return (
    <div>
      <div className="text-center mt50">
        <h3>Check your email</h3>
        <p className="subHeading">
          We’ve sent you a link to reset your password. Once your password is
          reset, try signing in again
        </p>
      </div>

      <div className="text-center mar-popup-image">
        <img src="/assets/svg/group.svg" alt="Email_sent" />
      </div>

      <div className="text-center mt75">
        <Link to="/signin" className="btn continue active">
          Return to sign in
        </Link>
      </div>
    </div>
  );
};

export default withRouter(ResetPasswordEmail);
